import api from 'shared/api'

const FETCH_REQUEST = 'companyRisk/FETCH_REQUEST';
const FETCH_SUCCESS = 'companyRisk/FETCH_SUCCESS';
const FETCH_FAILURE = 'companyRisk/FETCH_FAILURE';
const FILTER_REQUEST = 'companyRisk/FILTER_REQUEST'
const FILTER_SUCCESS = 'companyRisk/FILTER_SUCCESS'
const FILTER_FAILURE = 'companyRisk/FILTER_FAILURE'
const FETCH_ALL_REQUEST = 'companyRisk/FETCH_ALL_REQUEST'
const FETCH_ALL_SUCCESS = 'companyRisk/FETCH_ALL_SUCCESS'
const FETCH_ALL_FAILURE = 'companyRisk/FETCH_ALL_FAILURE'

const initialState = {
    result: [],
    total_size: 0,
    loaded: false,
    loading: false,
    filterLoaded: false,
    filterLoading: false,
    allResult: [],
    allLoaded: false,
    allLoading: false,
    errors: []
};

export function fetchRequest(payload = {}){
    return {
        type: FETCH_REQUEST
    }
}

export function fetchSuccess(payload){
    return {
        type: FETCH_SUCCESS,
        payload
    }
}

export function fetchFailure(errors = []){
    return {
        type: FETCH_FAILURE,
        errors
    }
}

export function filterRequest(payload = {}){
    return {
        type: FILTER_REQUEST
    }
}

export function filterSuccess(payload){
    return {
        type: FILTER_SUCCESS,
        payload
    }
}

export function filterFailure(errors = []){
    return {
        type: FILTER_FAILURE,
        errors
    }
}

export function fetchAllRequest(payload = {}){
    return {
        type: FETCH_ALL_REQUEST
    }
}

export function fetchAllSuccess(payload){
    return {
        type: FETCH_ALL_SUCCESS,
        payload
    }
}

export function fetchAllFailure(errors = []){
    return {
        type: FETCH_ALL_FAILURE,
        errors
    }
}

export function loadData(options = {}) {
    return (dispatch) => {
        dispatch(fetchRequest());

        return api('api/v1/company_risks', options, {}, true)
            .then(response => response.json().then(json => ({ json, response })))
            .then(({ json, response }) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchSuccess(json))
            })
            .catch((json) => {
                dispatch(fetchFailure(json.errors))
            });
    }
}

export function filterData(options = {}) {
    return (dispatch) => {
        dispatch(filterRequest());

        return api('api/v1/company_risks', options, {}, true)
          .then(response => response.json().then(json => ({ json, response })))
          .then(({ json, response }) => {
              if (!response.ok) {
                  return Promise.reject(json)
              }

              dispatch(filterSuccess(json))
          })
          .catch((json) => {
              dispatch(filterFailure(json.errors))
          });
    }
}

export function loadAllData(options = {}) {
    return (dispatch) => {
        dispatch(fetchAllRequest());

        return api('api/v1/company_risks', options, {}, true)
          .then(response => response.json().then(json => ({ json, response })))
          .then(({ json, response }) => {
              if (!response.ok) {
                  return Promise.reject(json)
              }

              dispatch(fetchAllSuccess(json))
          })
          .catch((json) => {
              dispatch(fetchAllFailure(json.errors))
          });
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const { payload, type, errors } = action;

    switch (type) {
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true
            });
        case FETCH_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                result: payload.result,
                total_size: payload.total_size
            });
        case FETCH_FAILURE:
            return Object.assign({}, state, {
                loaded: false,
                loading: false,
                errors
            });
        case FILTER_REQUEST:
            return Object.assign({}, state, {
                filterLoading: true
            });
        case FILTER_SUCCESS:
            return Object.assign({}, state, {
                filterLoading: false,
                filterLoaded: true,
                errors: [],
                result: payload.result,
                total_size: payload.total_size
            });
        case FILTER_FAILURE:
            return Object.assign({}, state, {
                filterLoaded: false,
                filterLoading: false,
                errors
            });
        case FETCH_ALL_REQUEST:
            return Object.assign({}, state, {
                fetchAllLoading: true
            });
        case FETCH_ALL_SUCCESS:
            return Object.assign({}, state, {
                fetchAllLoading: false,
                fetchAllLoaded: true,
                errors: [],
                allResult: payload.result
            });
        case FETCH_ALL_FAILURE:
            return Object.assign({}, state, {
                fetchAllLoaded: false,
                fetchAllLoading: false,
                errors
            });
        default:
            return state
    }
}